import Cookies from 'js-cookie'

let file = {
  // 通过XMLHttpRequest转换文件流 获取excel文件 callbackFile用于取消外部按钮loading效果，因为下载时间可能有点长 防止重复提交
  getExcelFile (obj, api, param, callbackFile) {
    var xmlResquest = new XMLHttpRequest()
    xmlResquest.open('POST', api, true)
    xmlResquest.setRequestHeader('Content-type', 'application/json')
    xmlResquest.setRequestHeader('source-type', 'web')
    xmlResquest.setRequestHeader('role-type', 'mgt')
    xmlResquest.setRequestHeader('system-type', '001')
    xmlResquest.setRequestHeader('Authorization', Cookies.get('AppAuthorization'))
    param ? xmlResquest.send(JSON.stringify(param)) : xmlResquest.send()
    xmlResquest.responseType = 'blob'
    xmlResquest.onload = () => {
      const content = xmlResquest.response
      const blob = new Blob([content])
      let name = xmlResquest.getResponseHeader('content-disposition')
      if (window.navigator.msSaveOrOpenBlob) { // 兼容IE
        let fileName = decodeURI(name.split('filename=')[1])
        navigator.msSaveBlob(blob, fileName)
      } else {
        if (xmlResquest.getResponseHeader('content-type') === 'application/json;charset=utf-8') {
          const reader = new FileReader()
          reader.readAsText(blob, 'utf-8')
          reader.onload = (e) => {
            obj.$message.error(JSON.parse(reader.result).errorMsg)
          }
          if (callbackFile) {
            callbackFile('fail')
          }
          return
        }
        var elink = document.createElement('a')
        elink.download = decodeURI(name.split('filename=')[1])
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
        if (callbackFile) {
          callbackFile('success')
        }
      }
    }
  },
}

export default file
